import { Box, TextField, Typography } from '@mui/material';
import { StoreFinderWidget } from 'api/stores/types';
import { StoreTable } from 'components/MenuManager/StoreTable.tsx/StoreTable';
import React, { FC, useEffect, useState } from 'react';

interface Props {
  stores: StoreFinderWidget[];
}

export const MenuManager: FC<Props> = ({ stores }) => {
  const [storeFilter, setStoreFilter] = useState<string>('');
  const [filteredStores, setFilteredStores] =
    useState<StoreFinderWidget[]>(stores);

  useEffect(() => {
    if (!storeFilter) {
      setFilteredStores(stores);
    } else {
      const lowerCaseFilter = storeFilter.toLowerCase();
      const filtered = stores.filter((store) =>
        store.storeNumber.toLowerCase().includes(lowerCaseFilter),
      );
      setFilteredStores(filtered);
    }
  }, [storeFilter, stores]);

  return (
    <Box width="1000px" margin="0 auto" p={5} overflow="scroll">
      <Typography variant="h2" color="#191919" mb={1}>
        MENU MANAGER
      </Typography>
      <Box ml={3} mb={6}>
        <Typography variant="body3" color="#191919">
          Get started building your MENU by first providing a <br /> name and
          short description of the menu you&apos;re creating.
        </Typography>
      </Box>
      <Box display="flex" justifyContent="flex-end" mb={4}>
        <TextField
          label="Search by Store Number"
          variant="outlined"
          style={{ width: '300px' }}
          value={storeFilter}
          onChange={(e) => setStoreFilter(e.target.value)}
        />
      </Box>
      <Box width={1}>
        {filteredStores.length > 0 ? (
          <StoreTable stores={filteredStores} />
        ) : (
          <Typography>No matching stores found.</Typography>
        )}
      </Box>
    </Box>
  );
};
